import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

const ShopByCategory = ({containerObject}) => {
  return (
    <div id="p404">
      <div class="grid-container p404-products">
        <div class="row">
          <div class="col-12 col-md-4">
          </div>
          <div class="col-12 col-md-8">
          <h1 className='justify-content-center d-flex mt-5 d-none'>{containerObject.attributes && containerObject.attributes.customPluginTitle ? containerObject.attributes.customPluginTitle : ""}</h1>
        
            {containerObject && containerObject.results.map((item) => {
              return (<>
                  <Link className="btn" to={item && item.categoryUrl ? item.categoryUrl : ""}>{item && item["category.categoryName"] ? item["category.categoryName"] : ""}</Link>
               </>)
            })}
          
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShopByCategory